import {
  SHOW_MESSAGE,
  CLOSE_MESSAGE,
  SET_LOADING
} from "./types";

const initialState = {
  snackbar: {
    message: "",
    open: false
  },
  loading: false
};

export const ui = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MESSAGE:
      return {
        ...state,
        snackbar: {
          message: action.payload,
          open: true
        }
      };
    case CLOSE_MESSAGE:
      return {
        ...state,
        snackbar: {
          message: "",
          open: false
        }
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    default:
      return state;
  }
};

export default ui;
